import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

/**
 * Conta le richieste HTTP in corso. Serve al PwaUpdateService per non ricaricare
 * l'app mentre una scrittura (es. prenotazione, presenza) e' ancora in volo.
 */
@Injectable({ providedIn: 'root' })
export class PendingRequestsInterceptor implements HttpInterceptor {
  private pending = 0;

  get count(): number {
    return this.pending;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.pending++;
    return next.handle(req).pipe(finalize(() => this.pending--));
  }
}
